import { render, staticRenderFns } from "./ApplicationBuildAnimation.vue?vue&type=template&id=8a5489b4&scoped=true"
import script from "./ApplicationBuildAnimation.vue?vue&type=script&lang=js"
export * from "./ApplicationBuildAnimation.vue?vue&type=script&lang=js"
import style0 from "./ApplicationBuildAnimation.vue?vue&type=style&index=0&id=8a5489b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5489b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5489b4')) {
      api.createRecord('8a5489b4', component.options)
    } else {
      api.reload('8a5489b4', component.options)
    }
    module.hot.accept("./ApplicationBuildAnimation.vue?vue&type=template&id=8a5489b4&scoped=true", function () {
      api.rerender('8a5489b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApplicationBuildAnimation.vue"
export default component.exports